// Routes redesigned in the learn group. Each entry: { path, element }.
// Entries here override the legacy routes in App.jsx for the same path.
import GuidesHub from "./GuidesHub.jsx";
import GuidePage from "./GuidePage.jsx";
import ProblemsHub from "./ProblemsHub.jsx";
import ProblemPage from "./ProblemPage.jsx";
import ProjectsPage from "./ProjectsPage.jsx";

export const routes = [
  { path: "/guides", element: <GuidesHub /> },
  { path: "/guides/:slug", element: <GuidePage /> },
  { path: "/problems", element: <ProblemsHub /> },
  { path: "/problems/:category", element: <ProblemPage /> },
  { path: "/projects", element: <ProjectsPage /> },
];
